/**
 * Foundation plugin for checkbox groups
 *
 * If a checkbox of one group got checked,
 * all checkboxes that belong to other groups get unchecked.
 *
 * Add the attribute "data-toggle-checkbox-group" to a parent element of all
 * checkboxes that should be handled and assign groups by adding the attribute
 * "data-checkbox-group='<group-name>'" to the checkboxes.
 */

import $ from 'jquery';

import { Foundation } from 'foundation-sites/js/foundation.core';

class ToggleCheckboxGroup {
    constructor(element, options) {
        this.$element = element;

        // listen for change events on checkboxes
        this.$element.on("change.toggleCheckboxGroup", "input[type='checkbox'][data-checkbox-group]", (e) => {
            let $target = $(e.target);

            if($target.prop('checked') == false) {
                // the checkbox got 'unchecked', so we have nothing to do
                return;
            };

            // the group of the checkbox that was checked
            let targetGroup = $target.attr("data-checkbox-group");

            // iterate through all checkboxes that belong to a group
            this.$element.find("input[type='checkbox'][data-checkbox-group]").each(function() {
                let $this = $(this);
                let group = $this.attr("data-checkbox-group");

                // if the checkbox belongs to another group, uncheck it
                if(group != targetGroup) {
                    $this.prop('checked', false);
                }
            });
        });

        Foundation.registerPlugin(this, 'ToggleCheckboxGroup');
    }
}

Foundation.plugin(ToggleCheckboxGroup, "ToggleCheckboxGroup");

export { ToggleCheckboxGroup };
